import React from 'react'

import {isNil} from 'es-toolkit'

import './_grid-cell.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children?: React.ReactNode
    s?: number
    m?: number
    l?: number
    stretch?: boolean // Set by Grid
  }
>

const GridCell = ({className, children, s = 12, m, l, stretch = false, ...props}: Props) => (
  <div
    {...props}
    className={cn(
      'GridCell',
      {
        [`s-${s}`]: !isNil(s),
        [`m-${m}`]: !isNil(m),
        [`l-${l}`]: !isNil(l),
        stretch,
      },
      className
    )}
  >
    {children}
  </div>
)

export default GridCell
